import { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import {
  confirmDraftDiscard,
  hasUnknownDraft,
  hasUnsavedDraft,
  registerDraftRouterGuard,
} from "./useUnsavedDraft";
/** Cover router PUSH/POP navigation as well as pointer-driven draft replacement. */
export default function DraftNavigationGuard() {
  const blocker = useBlocker(hasUnsavedDraft);
  useEffect(registerDraftRouterGuard, []);
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    if (hasUnknownDraft() || !confirmDraftDiscard()) blocker.reset();
    else blocker.proceed();
  }, [blocker]);
  return null;
}
